import { FormState } from "@episerver/forms-sdk";

const getFieldKeyByType = (formContext: FormState | null, elementType: string) => {
    // const formContext = useForms();

    if( formContext == null ) return

    const elements = formContext.formContainer.formElements;

    const element = elements.find((el) => {
        if( !(el as any).contentType ) return false;

        return (el as any).contentType === elementType;
    })

    return element ? element.key : null;
}

export default getFieldKeyByType;